export const reviewModalContentStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2,
		width: '100%'
	},

	noChangesText: {
		p: 2,
		color: 'text.secondary',
		fontStyle: 'italic'
	}
};
